"use client";

import { BRAND_NAME, BRAND_TAGLINE } from "@/lib/brand";
import { LogoNWordmark } from "@/components/brand/logo-n";
import { LogoAssetWordmark } from "@/components/brand/logo-asset";
import { useBrandLogoVariant } from "@/components/brand/logo-context";
import type { BrandLogoVariantId } from "@/lib/brand/logo-variant";

type LogoLayout = "full" | "compact" | "mark" | "sidebar";

type LogoProps = {
  showWordmark?: boolean;
  size?: number;
  layout?: LogoLayout;
  /** Явный вариант (превью в админке); иначе из BrandLogoProvider. */
  variant?: BrandLogoVariantId;
};

function LogoInner({
  showWordmark = true,
  size = 40,
  layout = "full",
  variant,
}: LogoProps) {
  const Wordmark = variant === "asset" ? LogoAssetWordmark : LogoNWordmark;

  if (layout === "sidebar") {
    return (
      <span aria-label={`${BRAND_NAME} ${BRAND_TAGLINE}`}>
        <Wordmark compact showTagline wordmarkOnly />
      </span>
    );
  }

  if (!showWordmark || layout === "mark") {
    return <Wordmark iconOnly iconSize={size} />;
  }

  return (
    <span aria-label={`${BRAND_NAME} ${BRAND_TAGLINE}`}>
      <Wordmark
        compact={layout === "compact"}
        showTagline={layout === "full"}
      />
    </span>
  );
}

export function Logo(props: LogoProps) {
  const fromContext = useBrandLogoVariant();
  return <LogoInner {...props} variant={props.variant ?? fromContext} />;
}

type LogoLinkProps = {
  size?: number;
  layout?: LogoLayout;
  href?: string;
  variant?: BrandLogoVariantId;
};

export function LogoLink({
  size = 40,
  layout = "full",
  href = "/",
  variant,
}: LogoLinkProps) {
  // Нативный <a>: Astryx Link оборачивает children в Text и даёт hydration mismatch на SVG-вордмарке.
  return (
    <a
      href={href}
      className="inline-flex min-w-0 max-w-full items-center text-inherit no-underline"
    >
      <Logo size={size} layout={layout} variant={variant} />
    </a>
  );
}
